import { render, staticRenderFns } from "./PsGroupsDialogPatients.vue?vue&type=template&id=97c64e7c&scoped=true&"
import script from "./PsGroupsDialogPatients.vue?vue&type=script&lang=js&"
export * from "./PsGroupsDialogPatients.vue?vue&type=script&lang=js&"
import style0 from "./PsGroupsDialogPatients.vue?vue&type=style&index=0&id=97c64e7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c64e7c",
  null
  
)

export default component.exports